"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyForm = void 0;
var axios_1 = __importDefault(require("axios"));
var react_1 = require("react");
var react_router_1 = require("react-router");
var useApplyForm = function () {
    var navigate = (0, react_router_1.useNavigate)();
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)({ name: "", email: "" }), user = _b[0], setUser = _b[1];
    // LINE認証チェック
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/user", {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(function (data) {
            if (!data.data.line_uid) {
                navigate("/main/apply");
            }
            setUser(data.data);
            setLoading(false);
        })
            .catch(function (_a) {
            var response = _a.response;
            if (response.data.error.type === "unauthorized") {
                alert("アカウント情報が存在しません。恐れ入りますが、再度認証手続きを行ってください。");
                localStorage.removeItem("token");
                navigate("/");
            }
        });
        return function () {
            setLoading(false);
        };
    }, []);
    var initialValues = {
        name: user.name,
        email: user.email ? user.email : "",
        zipcode: "",
        province: "",
        address1: "",
        address2: "",
        address3: "",
        phone: "",
        age: "",
        familyStructure: "",
        familyStructure_other: "",
        area: "",
        area_other: "",
        gas: "",
        gas_other: "",
        checked: false,
    };
    var validateName = function (value) {
        var error;
        if (!value) {
            error = "氏名を入力してください";
        }
        return error;
    };
    var validateMail = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!value) return [3 /*break*/, 1];
                    error = "メールアドレスを入力してください";
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, axios_1.default
                        .post("/api/mail", {
                        email: value,
                    }, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    })
                        .catch(function (_a) {
                        var response = _a.response;
                        error = response.data.error.message;
                    })];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, error];
            }
        });
    }); };
    var validateZipcode = function (value) {
        var error;
        if (value.match(/[^0-9]+/)) {
            error = "半角数字のみで入力してください";
        }
        return error;
    };
    var validateProvince = function (value) {
        var error;
        return error;
    };
    var validateAddress1 = function (value) {
        var error;
        return error;
    };
    var validateAddress2 = function (value) {
        var error;
        return error;
    };
    var validateAddress3 = function (value) {
        var error;
        return error;
    };
    var validatePhone = function (value) {
        var error;
        if (!value) {
            error = "電話番号を入力してください";
        }
        if (value.match(/[^0-9]+/)) {
            error = "半角数字のみで入力してください";
        }
        return error;
    };
    var validateFamilyStructure = function (value) {
        var error;
        if (!value) {
            error = "家族構成を入力してください";
        }
        return error;
    };
    var validateAge = function (value) {
        var error;
        if (!value) {
            error = "年代を入力してください";
        }
        return error;
    };
    var validateArea = function (value) {
        var error;
        if (!value) {
            error = "お住いの地域を入力してください";
        }
        return error;
    };
    var validateGas = function (value) {
        var error;
        return error;
    };
    var validateIsCheck = function (value) {
        var error;
        if (!value) {
            error = "同意が必要です";
        }
        return error;
    };
    var onSubmit = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var familyStructure, area, gas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    familyStructure = values.familyStructure === "その他" && values.familyStructure_other
                        ? values.familyStructure + "\uFF08" + values.familyStructure_other + "\uFF09"
                        : values.familyStructure;
                    area = values.area === "その他" && (values === null || values === void 0 ? void 0 : values.area_other)
                        ? values.area + "\uFF08" + values.area_other + "\uFF09"
                        : values.area;
                    gas = values.gas === "その他" && (values === null || values === void 0 ? void 0 : values.gas_other)
                        ? values.gas + "\uFF08" + values.gas_other + "\uFF09"
                        : values.gas;
                    return [4 /*yield*/, axios_1.default
                            .post("/api/present", {
                            name: values.name,
                            email: values.email,
                            zipcode: values.zipcode ? values.zipcode : null,
                            province: values.province ? values.province : null,
                            address1: values.address1 ? values.address1 : null,
                            address2: values.address2 ? values.address2 : null,
                            address3: values.address3 ? values.address3 : null,
                            phone: values.phone,
                            family_structure: familyStructure,
                            age: values.age,
                            area: area,
                            gas: gas || null,
                        }, {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        })
                            .then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                navigate("/main/apply/complete");
                                return [2 /*return*/];
                            });
                        }); })
                            .catch(function (error) {
                            if (error.response.data.error.type === "forbidden") {
                                alert("接続の有効期限が切れています。恐れ入りますが、再度認証手続きを行ってください。");
                                navigate("/");
                            }
                            else if (error.response.data.error.type === "validate") {
                                var customError = [];
                                customError["name"] =
                                    error.response.data.error.details.name &&
                                        error.response.data.error.details.name[0];
                                customError["email"] =
                                    error.response.data.error.details.email &&
                                        error.response.data.error.details.email[0];
                                customError["zipcode"] =
                                    error.response.data.error.details.zipcode &&
                                        error.response.data.error.details.zipcode[0];
                                customError["province"] =
                                    error.response.data.error.details.province &&
                                        error.response.data.error.details.province[0];
                                customError["address1"] =
                                    error.response.data.error.details.address1 &&
                                        error.response.data.error.details.address1[0];
                                customError["address2"] =
                                    error.response.data.error.details.address2 &&
                                        error.response.data.error.details.address2[0];
                                customError["address3"] =
                                    error.response.data.error.details.address3 &&
                                        error.response.data.error.details.address3[0];
                                customError["phone"] =
                                    error.response.data.error.details.phone &&
                                        error.response.data.error.details.phone[0];
                                actions.setErrors(customError);
                            }
                            else {
                                console.log("送信エラーです。");
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        loading: loading,
        user: user,
        initialValues: initialValues,
        validateName: validateName,
        validateMail: validateMail,
        validateZipcode: validateZipcode,
        validateProvince: validateProvince,
        validateAddress1: validateAddress1,
        validateAddress2: validateAddress2,
        validateAddress3: validateAddress3,
        validatePhone: validatePhone,
        validateAge: validateAge,
        validateFamilyStructure: validateFamilyStructure,
        validateArea: validateArea,
        validateGas: validateGas,
        validateIsCheck: validateIsCheck,
        onSubmit: onSubmit,
    };
};
exports.useApplyForm = useApplyForm;
